(function () {
  'use strict';

  angular.module('app').component('hotelRoomDetail', hotelRoomDetail());

  function hotelRoomDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        hotel: '=',
        onHotelRoomSaved: '&',
        onHotelRoomCanceled: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: HotelRoomDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/hotel-rooms/hotel-room-detail/hotel-room-detail.component.html',
    };
  }

  HotelRoomDetailComponent.$inject = [
    'UtilService',
    'HotelRoomService',

    // Angular downgraded service
    'facilityService',
    'facilityModalService',
    'occupancyTypeService',
    'occupancyTypeModalService',
    'roomTypeService',
    'roomTypeModalService',
    'utilService',
  ];

  function HotelRoomDetailComponent(
    UtilService,
    HotelRoomService,

    // Angular downgraded service
    facilityService,
    facilityModalService,
    occupancyTypeService,
    occupancyTypeModalService,
    roomTypeService,
    roomTypeModalService,
    utilService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.checkedFacility = {};

    // private properties
    // -----------------------
    const fieldsDefinition = [
      'name',
      'ideal_for',
      'description',
      'bed_configuration',
      'url_video',
      'max_occupancy',
      'children_allowed',
      'total_bedrooms',
      'base_availability',
      'size',
      'room_type_id',
      'occupancy_type_id',
      'facility_ids',
    ];

    var cropedImage = { file: null };

    // public methods
    // -----------------------
    vm.editHotelRoom = function () {
      vm.editMode = true;
      vm.viewMode = false;

      vm.setMaxOccupancy(vm.item.occupancy_type);
    };

    vm.cancelEdit = function () {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    };

    // Create/Update
    vm.saveHotelRoom = function (isFormValid) {
      vm.formErrors = false;

      const scrollTo = 'room_detail';

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop(scrollTo);

        return;
      }

      if (!vm.item.children_allowed) {
        vm.item.max_children_occupancy = 0;
      }

      // console.log(vm.item); return;

      vm.item.facility_ids = utilService.parseItemIds(vm.checkedFacility);

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        HotelRoomService.saveHotelRoom(vm.item, vm.hotel.id, vm.defaultLanguage, cropedImage).then(
          function (res) {
            let response = res.data;

            /* if (!vm.editMode) {
              // create
              vm.item = response; // reload item
            } */

            vm.item = response; // reload item

            setItemOptions(response);

            vm.onHotelRoomSaved({ item: response });

            vm.UtilService.scrollToTop(scrollTo);

            vm.sendingForm = false;
          },
          function (response) {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.data.errors);

            vm.formErrors = true;
            vm.UtilService.scrollToTop(scrollTo);

            vm.sendingForm = false;
          }
        );
      } else {
        vm.cancel();
      }
    };

    vm.cancel = function () {
      /*if (vm.editMode){
                vm.cancelEdit();
                return;
            }*/

      vm.onHotelRoomCanceled();
    };

    vm.setMaxOccupancy = function (occupancyType) {
      vm.maxOccupancy = occupancyType.occupancy;

      if (!vm.item.max_occupancy) {
        vm.item.max_occupancy = occupancyType.occupancy;
      }
    };

    vm.openLogo = function () {
      let logoSaved = (cropedImageObj) => {
        cropedImage = cropedImageObj;

        if (vm.editMode) {
          let updateLogoCallback = (data) => {
            vm.item.logo = data.logo;
            vm.item.logoUrl = vm.UtilService.cleanItemCache(data, 'logo');

            vm.originalItem.logo = angular.copy(vm.item.logo);
            vm.originalItem.logoUrl = angular.copy(vm.item.logoUrl);

            vm.item.logoUpdated = true;

            vm.onHotelRoomSaved({ item: vm.item });
          };

          HotelRoomService.updateLogo(vm.item, vm.hotel.id, cropedImage, updateLogoCallback);
        } else {
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>
          img.src = URL.createObjectURL(cropedImage.file);
        }
      };

      HotelRoomService.openLogo(vm.item, logoSaved);
    };

    vm.openHotelRoomTranslations = function () {
      HotelRoomService.openHotelRoomTranslations(vm.item, vm.hotel.id, vm.additionalLanguages);
    };

    vm.openRoomTypesModal = function () {
      roomTypeModalService.openRoomTypesModal(getRoomTypes);
    };

    vm.openOccupancyTypesModal = function () {
      // const successCallback = () => {
      //   getOccupancyTypes();
      // };

      occupancyTypeModalService.openOccupancyTypesModal(getOccupancyTypes);
    };

    vm.openFacilitiesModal = function () {
      const successCallback = () => {
        getFacilities();
      };

      facilityModalService.openFacilitiesModal(successCallback);
    };

    vm.onHotelRoomPhotosSaved = function (photos) {
      vm.item.photos = photos;
      vm.originalItem = angular.copy(vm.item); // store server data

      vm.onHotelRoomSaved({ item: vm.item });
    };

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        //New
        vm.createMode = true;

        vm.item = {
          children_allowed: true,
          total_bedrooms: 1,
          wifi: false,
          not_smoking: true,
        };

        vm.labelAddLogo = 'ADD_PHOTO';
      }

      getRoomTypes();
      getOccupancyTypes();
      getFacilities();
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editHotelRoom();
      }

      vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(item.url_video);

      setCheckedFacilities(item.facility_ids);

      vm.labelAddLogo = item.logo.url ? 'CHANGE_PHOTO' : 'ADD_PHOTO';

      vm.flashMessage = vm.UtilService._displayFlashMessage();

      vm.originalItem = angular.copy(item); // store server data
    }

    function getRoomTypes() {
      let params = {
        get: 'active',
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      vm.loadingRoomTypes = true;
      roomTypeService.getRoomTypes(params).subscribe((response) => {
        vm.roomTypes = response;

        vm.loadingRoomTypes = false;
      });
    }

    function getOccupancyTypes() {
      let params = {
        get: 'active',
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      vm.loadingOcupancyTypes = true;
      occupancyTypeService.getOccupancyTypes(params).subscribe((response) => {
        vm.occupancyTypes = response;

        vm.loadingOcupancyTypes = false;
      });
    }

    function getFacilities() {
      let params = {
        get: 'hotel_room',
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      facilityService.getFacilities(params).subscribe((response) => {
        vm.facilities = response;
      });
    }

    function setCheckedFacilities(facility_ids) {
      facility_ids.forEach((key) => {
        vm.checkedFacility[key] = true;
      });
    }
  }
})();
